import React from 'react';
import { cx } from '@/styled-system/css';
import { HeartFilledIcon, HeartOutlineIcon } from '../../../ui/icons';
import * as styles from './favoriteButton.styles';

export type SocialActionButtonProps = {
  onClick: () => void;
  'aria-label': string;
  disabled?: boolean;
  isSaved?: boolean;
  size?: 'sm' | 'md' | 'lg';
};

export const FavoriteButton = React.forwardRef<HTMLButtonElement, SocialActionButtonProps>(function FavoriteButton(
  { onClick, 'aria-label': ariaLabel, disabled = false, isSaved = false, size = 'md' },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      className={cx(styles.base, styles.sizes[size], isSaved ? styles.saved : styles.unsaved)}
      onClick={onClick}
      aria-label={ariaLabel}
      title={ariaLabel}
      disabled={disabled}
    >
      <span className={styles.iconWrapper} aria-hidden="true">
        {isSaved ? <HeartFilledIcon /> : <HeartOutlineIcon />}
      </span>
    </button>
  );
});
